// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-cls1__fc20767adb4d43df3624{/*!*/}.Header-cls2___39bf8eb08ed2ef758ac{--size: 48px}@media(min-width: 768px){.Header-cls2___39bf8eb08ed2ef758ac{--size: 60px}}.Header-cls2___39bf8eb08ed2ef758ac.Header-small___ff307bfa9aec261128b{--size: 32px}@media(min-width: 768px){.Header-cls2___39bf8eb08ed2ef758ac.Header-small___ff307bfa9aec261128b{--size: 40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Header-cls1__fc20767adb4d43df3624",
	"cls2": "Header-cls2___39bf8eb08ed2ef758ac Header-cls1__fc20767adb4d43df3624",
	"small": "Header-small___ff307bfa9aec261128b"
};
export default ___CSS_LOADER_EXPORT___;
